<template>
  <div class="accessRecords">
    <div class="icon_cont">
      <i @click="closeDialog" class="close_cont el-icon-close"></i>
    </div>
    <div class="table_title">出入记录</div>
    <div class="input_cont">
      <el-input
        :placeholder="accessRecordsProps.title === '门禁设备' ? '请输入姓名' : '请输入车牌号'"
        v-model="keyword"
        clearable
        class="input-with-select unglobal-sty"
      >
        <el-button
          class="unglobal-sty"
          slot="append"
          icon="el-icon-search"
          @click="searchData"
        ></el-button>
      </el-input>
      <el-input
        placeholder="请输入设备名称"
        v-model="searchDeviceName"
        clearable
        class="ml-10px input-with-select unglobal-sty"
      >
        <el-button
          class="unglobal-sty"
          slot="append"
          icon="el-icon-search"
          @click="searchData"
        ></el-button>
      </el-input>
    </div>
    <div class="table_cont">
      <el-table
        v-loading="loading"
        class="unglobal-sty"
        :data="accessRecordList"
        style="width: 100%"
        height="100%"
        ref="multipleTable"
      >
        <el-table-column type="index" width="50" label="序号" align="center"> </el-table-column>
        <el-table-column
          v-if="title === '门禁设备'"
          :show-overflow-tooltip="true"
          property="personName"
          key="personName"
          label="人员姓名"
          align="center"
        >
        </el-table-column>
        <el-table-column
          v-if="title === '车辆道闸'"
          :show-overflow-tooltip="true"
          property="carNumber"
          key="carNumber"
          label="车牌号"
          align="center"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="deviceName"
          label="设备名称"
          align="center"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="actionType"
          label="动作"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.actionType === 1 ? '进入' : '离开' }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          property="time"
          label="动作时间"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="tab_pog">
      <el-pagination
        class="unglobal-sty"
        background
        layout="prev, pager, next"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page.sync="page.pageNo"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import CockpitService from '../service/index'

export default {
  props: {
    accessRecordsProps: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      searchDeviceName: '',
      accessRecordList: [],
      page: {
        total: 0,
        pageSize: 15,
        pageNo: 1,
      },
      keyword: '',
      optionsList: [],
      valueName: '',
      accessOpen: false,
      title: '',
      loading: false,
    }
  },
  watch: {
    accessRecordsProps: {
      immediate: true,
      async handler(val) {
        this.page.pageNo = 1
        this.keyword = ''
        this.title = val.title
        this.getIotAccessRecord()
      },
    },
  },
  created() {
    this.title = this.accessRecordsProps.title
    this.getIotAccessRecord()
  },
  methods: {
    // 获取出入记录
    async getIotAccessRecord() {
      const params = {
        DeviceName: this.searchDeviceName,
        DeviceCode: this.accessRecordsProps.row.code,
        SkipCount: (this.page.pageNo - 1) * this.page.pageSize,
        MaxResultCount: this.page.pageSize,
      }
      let res = null
      if (this.title === '门禁设备') {
        params.PersonName = this.keyword
        const [err, result] = await CockpitService.getIotAccessRecord(params)
        res = result
      } else {
        params.CarNumber = this.keyword
        const [err, result] = await CockpitService.getIotBarrierAccessRecord(params)
        res = result
      }
      if (res) {
        this.accessRecordList = res.items
        this.page.total = res.totalCount
      }
    },
    closeDialog() {
      this.$emit('closeCurrDig')
      this.keyword = ''
    },
    searchData() {
      this.page.pageNo = 1
      this.getIotAccessRecord()
    },
    handleCurrentChange(val) {
      this.page.pageNo = val
      this.getIotAccessRecord()
    },
  },
}
</script>

<style lang="scss" scoped>
.ml-10px {
  margin-left: 10px;
}
.accessRecords {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 200px;
  top: 92px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: var(--dialogBgImg);
  padding: 10px;
}
.table_title {
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  text-align: center;
  margin-bottom: 15px;
}
.icon_cont {
  text-align: right;
  position: relative;
  height: 20px;
  .el-button {
    padding: 5px !important;
    background: #3fbaff4c !important;
    color: #fff;
  }
  .close_cont {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    border-radius: 2px;
    background: rgba(63, 186, 255, 0.2980392157) !important;
    color: #fff;
    cursor: pointer;
    border: 1px solid #d9d9d9;
  }
}
.input_cont {
  // width: 200px;
  margin-left: 20px;
  .el-input {
    width: 200px;
  }
  .el-select {
    margin-left: 10px;
  }
}
.table_cont {
  height: calc(100% - 150px);
  padding: 10px 20px;
}
.tab_pog {
  text-align: center !important;
}
::v-deep .el-input-group__append {
  background: transparent !important;
  color: #fff !important;
  .el-button {
    background: transparent !important;
    border-right: none !important;
  }
}
</style>
<style>
.accessRecords_sle {
  background: #24354c !important;
  color: #fff !important;
}
.accessRecords_sle .el-select-dropdown__item.hover {
  background-color: #409eff33 !important;
}
.accessRecords_sle .el-select-dropdown__item {
  color: #fff !important;
}
</style>
